import { CmtsEnterpriseForm, type CmtsFormField } from "../forms/index.js";
import type { DropdownOption } from "../../types/api.types.js";
import { buildCapaCreatePayload, type CapaCreatePayload } from "../../core/payloads/cmtsTypedPayloads.js";
import { mapRcaDropdownOptions } from "../rca/rcaOptionMappers.js";

export type CmtsCapaFormInitialValues = Partial<CapaCreatePayload>;

export type CmtsCapaFormProps = Readonly<{
  complaintId: string;
  actionTypes?: readonly DropdownOption[];
  owners?: readonly DropdownOption[];
  statuses?: readonly DropdownOption[];
  initialValues?: CmtsCapaFormInitialValues;
  busy?: boolean;
  error?: string | null;
  mode?: "create" | "edit";
  onSubmit: (payload: CapaCreatePayload) => void | Promise<void>;
  onCancel?: () => void;
}>;

export function CmtsCapaForm(props: CmtsCapaFormProps) {
  const fields: readonly CmtsFormField[] = [
    { name: "complaintId", label: "Complaint", type: "text", required: true, disabled: true },
    { name: "actionTypeId", label: "CAPA Action Type", type: "select", required: true, options: mapRcaDropdownOptions(props.actionTypes), disabled: !props.actionTypes?.length },
    { name: "actionDescription", label: "Action Description", type: "textarea", required: true, minLength: 5 },
    { name: "ownerUserId", label: "CAPA Owner", type: "select", required: true, options: mapRcaDropdownOptions(props.owners), disabled: !props.owners?.length },
    { name: "dueDate", label: "Due Date", type: "date", required: true },
    { name: "statusId", label: props.mode === "edit" ? "CAPA Status" : "Initial CAPA Status", type: "select", required: true, options: mapRcaDropdownOptions(props.statuses), disabled: !props.statuses?.length },
    { name: "effectivenessRequired", label: "Effectiveness Check Required", type: "select", required: true, options: [{ value: "true", label: "Yes" }, { value: "false", label: "No" }] },
    { name: "effectivenessCheckDate", label: "Effectiveness Check Date", type: "date" },
  ];

  return <CmtsEnterpriseForm
    fields={fields}
    initialValues={{ complaintId: props.complaintId, effectivenessRequired: false, ...props.initialValues }}
    submitLabel={props.mode === "edit" ? "Update CAPA" : "Create CAPA"}
    busy={props.busy}
    error={props.error}
    onCancel={props.onCancel}
    onSubmit={(values) => props.onSubmit(buildCapaCreatePayload(values))}
  />;
}
